import {Component, EventEmitter, HostListener, OnInit, Output} from '@angular/core';
import {Observable} from 'rxjs';
import {CustomerViewModel} from '../../../model/view/CustomerViewModel';
import {CustomersService} from '../../../services/customers.service';
import {debounceTime, filter, switchMap, tap} from 'rxjs/operators';
import {ComponentAsElement} from '../../../services/common/bootstrap/annotation/component-as-element';
import {UtilsEngi} from '../../tools/UtilsEngi';

@ComponentAsElement('v-asm-customer-search-element')
@Component({
  selector: 'v-asm-customer-search',
  templateUrl: './asm-customer-search.component.html',
  styleUrls: []
})
export class AsmCustomerSearchComponent implements OnInit {
  static readonly minimumCharacters = 3;

  public customersObs: Observable<CustomerViewModel[]>;
  public showSearchResult = false;

  @Output()
  public customerSelected = new EventEmitter();

  public selectedCustomerLabel = '';

  private inputStreamObs = new EventEmitter<string>();

  public searching = false;

  constructor(
    private customerService: CustomersService
  ) {
  }

  ngOnInit() {
    this.customersObs = this.inputStreamObs.pipe(
      debounceTime(500),
      switchMap(value => this.findByNameOrEmailOnServer(value)),
      tap(() => {
        this.showSearchResult = true;
        this.searching = false;
      })
    );
  }

  @HostListener('click')
  detectedClickOnElement(event: UIEvent) {
    event.stopPropagation();
    event.preventDefault();
  }

  @HostListener('document:click')
  detectedClickOutOfElement() {
    this.showSearchResult = false;
  }

  public inputUpdateDetected($event): void {
    if (!UtilsEngi.hasMinimumCharacters($event, AsmCustomerSearchComponent.minimumCharacters)) {
      this.showSearchResult = false;
    } else {
      this.inputStreamObs.emit($event);
    }
  }

  public selectCustomerDetected(_customer: CustomerViewModel): void {
    this.showSearchResult = false;
    this.broadcastThatCustomerSelected(_customer);
    this.selectedCustomerLabel = _customer.name;
  }

  public findByNameOrEmailOnServer(value: string): Observable<CustomerViewModel[]> {
    this.searching = true;
    return this.customerService.findByNameOrEmail(value);
  }

  private broadcastThatCustomerSelected(customer: CustomerViewModel): void {
    this.customerSelected.emit(customer);
  }
}
